import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BusterCollarAction, NoteAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-buster-collar-slot',
    templateUrl: './buster-collar-slot.component.html',
    styleUrl: './buster-collar-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BusterCollarSlotComponent implements SheetSlotComponentBase {

	@Input() action!: BusterCollarAction;
	value = null;

	constructor() {
	}
}